import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { CartCustomerPage } from 'src/app/modals/cart-customer/cart-customer.page';
import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller';

const routes: Routes = [
  {
    path: '',
    component: CartCustomerPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes),
    VirtualScrollerModule
  ],
  declarations: [CartCustomerPage]
})
export class CartCustomerPageModule {}
